<template>
  <el-row type="flex" align="middle" justify="start" class="tg-header--content">
    <tg-header-logo v-if="showLogo" :site="site"></tg-header-logo>
    <el-row type="flex" align="middle" justify="start" class="tg-header--title">
      <div class="title">
        <slot>{{title}}</slot>
      </div>
      <el-row type="flex" class="online" v-if="showOnline">
        <span>{{$t('component.header.online.member', {num: member})}}</span>
        <span>｜</span>
        <span>{{$t('component.header.online.agent', {num: agent})}}</span>
      </el-row>
    </el-row>
  </el-row>
</template>

<script>
import TgHeaderLogo from "@/components/header/TgHeaderLogo";
import { headerTitleProps } from "./utils";

export default {
  components: {
    TgHeaderLogo,
  },
  props: headerTitleProps,
};
</script>